<template>
  <div id="app">
    <meta name="viewport"
          content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
    <meta name="apple-mobile-web-app-capable"
          content="yes">
    <div class="content">
      <p class="back" @click="goback" v-show="$route.name != 'Index'"><i class="el-icon-back"></i></p>
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
  methods:{
    goback(){
      this.$router.back()
    }
  }
  
}
</script>

<style scoped>
@import "./assets/common/css/reset.css";
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  margin: 0 auto;
}
.content{
  width: 100%;
}
.back{
  padding-top: 20px;
  padding-left: 20px;
}
.back i{
  font-size: 24px;
}
.copyright{
  position: relative;
  bottom: 10px;
  left: 0;
  right: 0;
}
.copyright p{
  font-size: 12px;
  width: 350px;
  text-align: center;
  color: #999;
  margin:0 auto;
}
</style>
